import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { GovukpayPage } from './govukpay.page';

const routes: Routes = [
  {
    path: '',
    component: GovukpayPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GovukpayPageRoutingModule {}
